import { AlertaBannerHome } from '@/models/respuestas/usuario.model';
import { FC } from 'react';
import Alerta from './Alerta';

const CarruselAlertas: FC<{ alertas: AlertaBannerHome[] }> = ({ alertas }) => {
  // Cuando se quiera agregar mas tipos de alertas habrá que agregar un slider
  if (alertas?.length === 0) return null;

  return (
    <>
      {alertas.map((a, i) => (
        <Alerta {...a} key={i} />
      ))}
    </>
  );
};

export default CarruselAlertas;
